export const isError = (err: any) => {
  if (err && typeof err === "object" && "error_type" in err) {
    return true;
  }
  return false;
};
export const isGeneralError = (err: any) => {
  return isError(err) && err.error_type === "GENERAL";
};

export const isServerError = (err: any) => {
  return isError(err) && err.error_type === "SERVER_ERROR";
};

export const isConnectionError = (err: any) => {
  return isError(err) && err.error_type === "LOST_CONNECTION";
}
